<style scoped>
.resource-container {
  display: flex;
  padding: 10px;
  background: #fff;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  /* align-items: center; */
}

.resource-avatar {
  margin-right: 10px;
}

.resource-body {
  /* overflow: hidden; */
  display: flex;
  width: calc(100% - 75px);
  /* justify-content: space-between; */
  /* align-items: center; */
}

.resource-content > h3 {
  /* white-space: nowrap; */
  font-weight: 300;
  width: 100%;
  /* overflow: hidden; */
  /* text-overflow: ellipsis; */
}

.resource-content {
  overflow: hidden;
  margin-right: 30px;
}
</style>


<template>
  <app-layout class="resource-menu-page-template">
    <Row type="flex" justify="center">
      <div v-if="discover && discover.length == 0 && !isLoading" style="width: 100%; margin: 10px; text-align: center;">
        <span>
          No items
        </span>
      </div>
      <i-col :span="24" v-for="item in discover" :key="item.id">
        <div class="resource-container" v-on:click="redirectExtras(item)">
          <div class="resource-avatar">
            <Avatar :src="menuPreviewImage(item)" style="width:70px;height:70px" shape="square" size="large"></Avatar>
          </div>
          <div class="resource-body">
            <div class="resource-content">
                <h3 class="multiline-ellipsis">{{item.title}}</h3>
            </div>
          </div>
        </div>
      </i-col>
    </Row>
  </app-layout>
</template>


<script>
import VueCookie from 'vue-cookie'
import _ from 'lodash';
import Utils from '@/utils.js'
import Cons from '@/constants.json'

export default {
  name: 'SubMenuComponent',
  data() {
    return {
      isLoading: false
    }
  },
  mounted() {
    this.loadSubmenu()
    this.getCountryProvinceCity();
  },
  computed: {
    discover: {
      get() {
        return _.orderBy(this.$store.state.resource.resources.submenu.pages, 'order')
      }
    },
    nearbyId: {
      get() {
        return this.$store.state.user.nearby.city.id || this.$store.state.user.nearby.province.id || this.$store.state.user.nearby.country.id || ''
      }
    },
    groupId() {
      return this.$route.params.groupId
    }
  },
  watch: {
    groupId(n, o) {
      if (n != o)
        this.loadSubmenu()
    }
  },
  methods: {
    loadSubmenu() {
      this.isLoading = true
      this.$store.dispatch('resource/getSubmenu', this.groupId)
        .finally(() => {
          this.isLoading = false
        })
    },
    redirectExtras(item){
        if(item.type == 'group_page') {
          this.$router.push({ path: '/resources/' + item.data.careplan_id + '?tab=posts' })
          return false;
        }

        if(item.type == 'group_page_type') {
          this.$router.push({ path: '/group-type/' + item.data.group_type })
          return false;
        }

        if(item.type == 'module_page') {
          this.$router.push({ path: '/module/' + item.data.module_id + '?tab=course'})
          return false;
        }

        if(item.type == 'element_page') {
          this.$router.push({ path: '/feed/' + item.data.element_id})
          return false;
        }

        if (item.type == 'sub_menu') {
          this.$router.push({path: '/submenu/' + item.data.group_id})
          return false;
        }

        if(item.type == 'add_ons') {
          if( item.data.add_on_slug === 'events')
            this.$router.push({ path: '/events' })
          if( item.data.add_on_slug === 'videos')
            this.$router.push({ path: '/videos' })
          if( item.data.add_on_slug === 'faq')
            this.$router.push({ path: '/faq' })
          if(item.data.add_on_slug == "latest")
            this.goToPeople(Cons[0].GROUP_ID.donate,"Latest");
          if(item.data.add_on_slug == "nearby")
            this.goToPeople(this.nearbyId, "Nearby")
          return false;
        }

        if(item.type != 'hybrid') {
          this.$router.push({ path: '/feed/' + item.id })
        } else {
          this.$router.push({ path: '/extras/' + item.id })
        }
    },
    goToPeople(id,title){
        this.$router.push({
            path: "/people", query:{id: id, section:title}
        })
    },
    menuPreviewImage (act) {
      if( act.thumbnail_photo_uri ) {
        return Utils.getDisplayImage('activity_thumbnail', act, 'medium')
      } else {
        if(act.type === 'add_ons') {
          if(!act.cover_photo) {
            if( act.data.add_on_slug === 'events')
              return require('@/assets/resources/Events.png')
            if( act.data.add_on_slug === 'videos')
              return require('@/assets/resources/Videos.png')
            if( act.data.add_on_slug === 'faq')
              return require('@/assets/resources/FAQ.png')
          } else {
            return Utils.getDisplayImage('activity', act, 'medium')
          }
        }
      }
    },
    getCountryProvinceCity(){
        this.$store.dispatch("user/getCountryProvinceCity")
    }
  }
}

</script>

